import { render, staticRenderFns } from "./ClaimsView.vue?vue&type=template&id=451daa1e&scoped=true&"
import script from "./ClaimsView.vue?vue&type=script&lang=js&"
export * from "./ClaimsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451daa1e",
  null
  
)

export default component.exports